import { useEffect } from 'react';

import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

export function Page404() {
  useEffect(() => {
    sendGlobalErrorProps({
      errorType: 'notFoundError',
    });
  }, []);

  return <></>;
}

export default Page404;
